<app-page-header title="Questionnaires"></app-page-header>
<nexus-grid [data]="questionnaires_model">
  <kendo-grid-column field="questionnaire_template_name" title="Type"  [width]="350"></kendo-grid-column>
  <kendo-grid-column field="date_updated" title="Updated" format="G" filter="date" [width]="200" filter="date"></kendo-grid-column>
  <kendo-grid-column field="status" [width]="200" title="Status">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span  *ngIf="dataItem.status == 'Incomplete'" class="badge rounded-pill incomplete">{{ dataItem.status }}</span>
      <span  *ngIf="dataItem.status == 'PendingApproval'" class="badge rounded-pill pending-approval">Pending Approval</span>
      <span  *ngIf="dataItem.status == 'Approved'" class="badge rounded-pill approved">{{ dataItem.status }}</span>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="notes" title="Notes">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span  *ngIf="dataItem.status == 'Incomplete' && dataItem.additional_note ==null">Please complete the assigned questionnaire</span>
      <span  *ngIf="dataItem.status == 'Incomplete' && dataItem.additional_note">Please review the Notes section of this questionnaire</span>
      <span  *ngIf="dataItem.status == 'PendingApproval'">SimpleBills is reviewing the details shared</span>
      <span  *ngIf="dataItem.status == 'Approved'">Details shared have been reviewed and approved</span>
    </ng-template>

  </kendo-grid-column>
  <kendo-grid-column field="id" title="" [filterable]="false" [sortable]="false" [columnMenu]="false" [width]="150">
    <ng-template kendoGridCellTemplate let-dataItem>
      <a class="btn btn-secondary" [routerLink]="[dataItem.id]">Open</a>
    </ng-template>
  </kendo-grid-column>
</nexus-grid>

